





















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import LendingDialog from './LendingDialog.vue'

import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { DateTime } from '@/utils/filters'
import { statusMap } from '@/utils/status-map'
import { Bank, Channel } from '@/api/model/channel'

@Component({
    components: {
        SearchForm,
        TableForm,
        LendingDialog
    }
})
export default class extends Vue {
    dateTime = DateTime
    searchForm = {
        current: 1,
        size: 10,
        channelId: null,
        bankId: null,
        status: null
    }
    statusOptions = statusMap.createArray()
    channelOptions: Channel[] = []
    bankOptions: Bank[] = []

    tableLoading = false
    tableData = []
    total = 0

    formProp = {}
    show = false
    disabled = false

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
    }

    getChannels() {
        $Api.channelService
            .queryChannelDropdown()
            .subscribe(data => {
                this.channelOptions = data
            })
    }

    getBanks() {
        $Api.channelService
            .queryAbroadBankDropdown()
            .subscribe(data => {
                this.bankOptions = data
            })
    }

    getData(pageQuery = {}) {
        this.tableLoading = true
        $Api.routingService
            .outComeRouteManageList(Object.assign(this.searchForm, pageQuery))
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.list
                this.total = data.total
            })
    }

    // 新建
    create() {
        this.formProp = {}
        this.show = true
        this.disabled = false
    }

    // 编辑
    modify(row: any) {
        this.formProp = { ...row }
        this.show = true
        this.disabled = false
    }

    // 查看
    view(row: any) {
        this.formProp = { ...row }
        this.show = true
        this.disabled = true
    }

    created() {
        this.getData()
        this.getChannels()
        this.getBanks()
    }
}
